import { Component, OnDestroy, OnInit } from "@angular/core";
import { LanguageService } from "../../services/language.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppValidationsHelper } from "projects/admin/src/app/app-validations.helper";
import { LegacyService } from "../../services/legacy.service";

@Component({
  selector: 'delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.css']
})
export class DeleteAccountComponent implements OnInit, OnDestroy {

  form: FormGroup;

  completed: boolean = false;

  loading: boolean = false;

  authError: boolean = false;

  error: boolean = false;

  constructor(
    private fb: FormBuilder,
    private legacyService: LegacyService,
    public language: LanguageService) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      email: [null, [Validators.compose([Validators.required, Validators.email])]],
      password: [null, Validators.required],
      reason: [null, Validators.required],
      info: [null],
    });
  }

  ngOnDestroy(): void {
    
  }

  deleteAccount() {
    this.form.setErrors(null);
    this.form.markAsDirty();
    this.form.markAsTouched();
    this.authError = false;
    this.error = false;

    if (this.form.valid) {
      this.loading = true;
      this.doAuth();
    } else {
      this.loading = false;
      AppValidationsHelper.validateFormFields(this.form);
    }
  }

  private doAuth() {
    this.legacyService.access({
      email: this.form.value.email,
      password: this.form.value.password
    })
    .toPromise()
    .then(data => {
      this.sendRequest(data.accessToken);
    }, error => {
      this.loading = false;
      if (error.code === 14) {
        this.authError = true;
      } else {
        this.error = true;
      }
    });
  }

  private sendRequest(accessToken: string) {
    const params = {
      reason: this.form.value.reason,
      info: null
    };
    if (this.form.value.info && this.form.value.info.trim().length > 0) {
      params.info = this.form.value.info.trim();
    }
    this.legacyService.deleteUser(accessToken, params)
    .toPromise()
    .then(data => {
      this.loading = true;
      this.completed = true;
    }, error => {
      this.loading = false;
      this.error = true;
    });
  }
}
